import { IAction } from 'types/action';
import {
    STEP_ADDITIONAL_INFO,
    STEP_EMAIL_VERIFICATION,
    STEP_LANDING,
    STEP_LOGIN,
    STEP_PLATFORM_SELECTION,
    STEP_REDEMPTION_ERROR,
    STEP_REDEMPTION_SUCCESS,
    STEP_ITEMS_DISPLAY_PAGE,
    STEP_ITEM_SELECTION_PAGE,
    STEP_OWN_ALL_ITEMS_ERROR
} from '../../router/router.constants';
import { initialState, IState } from 'modules/router/router.reducer';

import {
    LANDING,
    LOGIN,
    PLATFORM_SELECTION,
    REDEEM_SUCCESS,
    ITEMS_DISPLAY_PAGE,
    ITEM_SELECTION_PAGE,
    ADDITIONAL_INFO,
    ERROR_MESSAGE,
    ERROR_MESSAGE_GENERIC_ERROR,
    ERROR_MESSAGE_NOT_ELIGIBLE,
    ERROR_MESSAGE_CODE_ALREADY_REDEEMED,
    ERROR_MESSAGE_USER_ALREADY_REDEEMED,
    ERROR_OWN_ALL_ITEMS, ERROR_MAINTENANCE
} from '../../states/states.constants';
import {
    EMAIL_VERIFICATION
} from 'modules/email-verification/email-verification.constants';
import { SWITCH_PREVIEW_STATE_HOST } from '@sitegen/common/types/root-actions';

export const router = (state = initialState, action: IAction): IState => {
    switch (action.type) {
    case SWITCH_PREVIEW_STATE_HOST: {
        switch (action.payload) {
        case LANDING:
            return {
                currentView: STEP_LANDING
            };
        case LOGIN:
            return {
                currentView: STEP_LOGIN
            };
        case EMAIL_VERIFICATION.NOT_COMPLETED:
        case EMAIL_VERIFICATION.SENDING:
        case EMAIL_VERIFICATION.SENT:
            return {
                currentView: STEP_EMAIL_VERIFICATION
            };
        case PLATFORM_SELECTION:
            return {
                currentView: STEP_PLATFORM_SELECTION
            };
        case ITEMS_DISPLAY_PAGE:
            return {
                currentView: STEP_ITEMS_DISPLAY_PAGE
            };
        case ITEM_SELECTION_PAGE:
            return {
                currentView: STEP_ITEM_SELECTION_PAGE
            };
        case ERROR_OWN_ALL_ITEMS:
            return {
                currentView: STEP_OWN_ALL_ITEMS_ERROR
            };
        case REDEEM_SUCCESS:
            return {
                currentView: STEP_REDEMPTION_SUCCESS
            };
        case ADDITIONAL_INFO:
            return {
                currentView: STEP_ADDITIONAL_INFO
            };
        case ERROR_MESSAGE:
        case ERROR_MAINTENANCE:
        case ERROR_MESSAGE_GENERIC_ERROR:
        case ERROR_MESSAGE_NOT_ELIGIBLE:
        case ERROR_MESSAGE_CODE_ALREADY_REDEEMED:
        case ERROR_MESSAGE_USER_ALREADY_REDEEMED:
            return {
                currentView: STEP_REDEMPTION_ERROR
            };
        default:
            return state;
        }
    }
    default:
        return state;
    }
};

export default router;
